import React, { useMemo, useState } from "react";
import {
    Search,
    Filter,
    Eye,
    X,
    ChevronDown,
    RotateCcw,
    Phone,
    Heart,
    User,
} from "lucide-react";

const initialMembers = [
    {
        id: 1,
        memberId: "JP10001",
        name: "Arun Kumar",
        gender: "Male",
        placeOfBirth: "Erode",
        dateOfBirth: "1992-05-15",
        timeOfBirth: "08:30 AM",
        mobile: "9876543210",
        fatherName: "R. Rajendran",
        motherName: "P. Lakshmi",
        community: "Kongu Vellalar",
        subCommunity: "Vellalar",
        caste: "Gounder",
        nativePlace: "Erode",
        siblings: 1,
        familyType: "Joint Family",
        education: "B.E",
        occupation: "Software Engineer",
        company: "ABC Technologies",
        designation: "Senior Developer",
        annualIncome: "₹8,00,000",
        workLocation: "Coimbatore",
        languages: "Tamil, English",
        height: "5'8\"",
        weight: "70 Kg",
        color: "Fair",
        maritalStatus: "Unmarried",
        profilePicture: "",
        profileCreatedBy: "Branch Admin",
        familyTemple: "Sri Mariamman Temple",
        familyTemplePlace: "Erode",
        familyAssets: "Own House, Land",
        branch: "Erode Main Branch",
        pincode: "638001",
        state: "Tamil Nadu",
        district: "Erode",
        horoscope: "Available",
        status: "Active",
    },
    {
        id: 2,
        memberId: "JP10002",
        name: "Priya Devi",
        gender: "Female",
        placeOfBirth: "Coimbatore",
        dateOfBirth: "1995-08-21",
        timeOfBirth: "10:15 AM",
        mobile: "9876543211",
        fatherName: "S. Kumar",
        motherName: "R. Meena",
        community: "Kongu Vellalar",
        subCommunity: "Vellalar",
        caste: "Gounder",
        nativePlace: "Coimbatore",
        siblings: 2,
        familyType: "Nuclear Family",
        education: "M.Com",
        occupation: "Accountant",
        company: "XYZ Pvt Ltd",
        designation: "Senior Accountant",
        annualIncome: "₹6,00,000",
        workLocation: "Coimbatore",
        languages: "Tamil, English",
        height: "5'4\"",
        weight: "58 Kg",
        color: "Wheatish",
        maritalStatus: "Unmarried",
        profilePicture: "",
        profileCreatedBy: "Self",
        familyTemple: "Murugan Temple",
        familyTemplePlace: "Coimbatore",
        familyAssets: "Own House",
        branch: "Coimbatore Branch",
        pincode: "641001",
        state: "Tamil Nadu",
        district: "Coimbatore",
        horoscope: "Available",
        status: "Active",
    },
    {
        id: 3,
        memberId: "JP10003",
        name: "Suresh Kumar",
        gender: "Male",
        placeOfBirth: "Salem",
        dateOfBirth: "1990-02-10",
        timeOfBirth: "06:45 PM",
        mobile: "9876543212",
        fatherName: "K. Shanmugam",
        motherName: "V. Selvi",
        community: "Naidu",
        subCommunity: "Balija",
        caste: "Naidu",
        nativePlace: "Salem",
        siblings: 2,
        familyType: "Joint Family",
        education: "MBA",
        occupation: "Business",
        company: "Own Business",
        designation: "Managing Director",
        annualIncome: "₹12,00,000",
        workLocation: "Salem",
        languages: "Tamil, English, Telugu",
        height: "5'9\"",
        weight: "76 Kg",
        color: "Fair",
        maritalStatus: "Divorced",
        profilePicture: "",
        profileCreatedBy: "Branch Admin",
        familyTemple: "Perumal Temple",
        familyTemplePlace: "Salem",
        familyAssets: "House, Land, Car",
        branch: "Salem Branch",
        pincode: "636001",
        state: "Tamil Nadu",
        district: "Salem",
        horoscope: "Not Available",
        status: "Active",
    },
    {
        id: 4,
        memberId: "JP10004",
        name: "Kavitha R",
        gender: "Female",
        placeOfBirth: "Tiruppur",
        dateOfBirth: "1997-11-05",
        timeOfBirth: "04:20 AM",
        mobile: "9876543213",
        fatherName: "R. Murugan",
        motherName: "S. Devi",
        community: "Kongu Vellalar",
        subCommunity: "Vellalar",
        caste: "Gounder",
        nativePlace: "Tiruppur",
        siblings: 1,
        familyType: "Nuclear Family",
        education: "B.Sc",
        occupation: "HR Executive",
        company: "Fashion Textiles",
        designation: "HR Executive",
        annualIncome: "₹5,00,000",
        workLocation: "Tiruppur",
        languages: "Tamil, English",
        height: "5'3\"",
        weight: "55 Kg",
        color: "Wheatish",
        maritalStatus: "Unmarried",
        profilePicture: "",
        profileCreatedBy: "Self",
        familyTemple: "Amman Temple",
        familyTemplePlace: "Tiruppur",
        familyAssets: "Own House",
        branch: "Tiruppur Branch",
        pincode: "641601",
        state: "Tamil Nadu",
        district: "Tiruppur",
        horoscope: "Available",
        status: "Inactive",
    },
];

const emptyFilters = {
    branch: "",
    pincode: "",
    state: "",
    district: "",
    community: "",
    subCommunity: "",
    caste: "",
    gender: "",
    profession: "",
    horoscope: "",
};

function Members() {
    const [members, setMembers] = useState(initialMembers);

    const [searchType, setSearchType] = useState("memberId");
    const [searchText, setSearchText] = useState("");

    const [filters, setFilters] = useState(emptyFilters);
    const [showFilters, setShowFilters] = useState(true);

    const [viewMember, setViewMember] = useState(null);
    

    const filteredMembers = useMemo(() => {
        return members.filter((member) => {
            const searchValue = searchText.toLowerCase().trim();

            let searchMatch = true;

            if (searchValue) {
                if (searchType === "memberId") {
                    searchMatch = member.memberId
                        .toLowerCase()
                        .includes(searchValue);
                }

                if (searchType === "mobile") {
                    searchMatch = member.mobile.includes(searchValue);
                }

                if (searchType === "name") {
                    searchMatch = member.name
                        .toLowerCase()
                        .includes(searchValue);
                }
            }

            const filterMatch =
                (!filters.branch || member.branch === filters.branch) &&
                (!filters.pincode || member.pincode === filters.pincode) &&
                (!filters.state || member.state === filters.state) &&
                (!filters.district || member.district === filters.district) &&
                (!filters.community ||
                    member.community === filters.community) &&
                (!filters.subCommunity ||
                    member.subCommunity === filters.subCommunity) &&
                (!filters.caste || member.caste === filters.caste) &&
                (!filters.gender || member.gender === filters.gender) &&
                (!filters.profession ||
                    member.occupation === filters.profession) &&
                (!filters.horoscope ||
                    member.horoscope === filters.horoscope);

            return searchMatch && filterMatch;
        });
    }, [members, searchText, searchType, filters]);

    const clearFilters = () => {
        setSearchText("");
        setFilters(emptyFilters);
    };

    const toggleStatus = (id) => {
        setMembers((prev) =>
            prev.map((member) =>
                member.id === id
                    ? {
                        ...member,
                        status:
                            member.status === "Active"
                                ? "Inactive"
                                : "Active",
                    }
                    : member
            )
        );
    };

    const uniqueValues = (key) => {
        return [...new Set(members.map((item) => item[key]))];
    };

    return (
        <div className="members-page">

            {/* PAGE HEADER */}
            <div className="page-header">
                <div>
                    <h1>Members</h1>
                    <p>Manage matrimonial member profiles</p>
                </div>
            </div>

            {/* SUMMARY */}
            <div className="member-summary">

                <div className="member-summary-card">
                    <div className="summary-icon blue">
                        <User size={20} />
                    </div>

                    <div>
                        <span>Total Members</span>
                        <strong>{members.length}</strong>
                    </div>
                </div>

                <div className="member-summary-card">
                    <div className="summary-icon green">
                        <User size={20} />
                    </div>

                    <div>
                        <span>Active Members</span>
                        <strong>
                            {
                                members.filter(
                                    (member) => member.status === "Active"
                                ).length
                            }
                        </strong>
                    </div>
                </div>

                <div className="member-summary-card">
                    <div className="summary-icon pink">
                        <Heart size={20} />
                    </div>

                    <div>
                        <span>Male Members</span>
                        <strong>
                            {
                                members.filter(
                                    (member) => member.gender === "Male"
                                ).length
                            }
                        </strong>
                    </div>
                </div>

                <div className="member-summary-card">
                    <div className="summary-icon orange">
                        <Heart size={20} />
                    </div>

                    <div>
                        <span>Female Members</span>
                        <strong>
                            {
                                members.filter(
                                    (member) => member.gender === "Female"
                                ).length
                            }
                        </strong>
                    </div>
                </div>

            </div>

            {/* SEARCH + FILTER */}
            <div className="member-filter-card">

                <div className="member-search-row">

                    <div className="search-type">
                        <select
                            value={searchType}
                            onChange={(e) =>
                                setSearchType(e.target.value)
                            }
                        >
                            <option value="memberId">Member ID</option>
                            <option value="mobile">Mobile Number</option>
                            <option value="name">Member Name</option>
                        </select>
                    </div>

                    <div className="member-search-box">
                        <Search size={18} />

                        <input
                            type="text"
                            placeholder={
                                searchType === "memberId"
                                    ? "Search Member ID..."
                                    : searchType === "mobile"
                                        ? "Search Mobile Number..."
                                        : "Search Member Name..."
                            }
                            value={searchText}
                            onChange={(e) =>
                                setSearchText(e.target.value)
                            }
                        />

                        {searchText && (
                            <button
                                onClick={() => setSearchText("")}
                                className="search-clear"
                            >
                                <X size={16} />
                            </button>
                        )}
                    </div>

                    <button
                        className="filter-btn"
                        onClick={() =>
                            setShowFilters(!showFilters)
                        }
                    >
                        <Filter size={17} />
                        Filters
                        <ChevronDown
                            size={16}
                            className={
                                showFilters ? "rotate-180" : ""
                            }
                        />
                    </button>

                    <button
                        className="reset-btn"
                        onClick={clearFilters}
                    >
                        <RotateCcw size={16} />
                        Reset
                    </button>

                </div>

                {showFilters && (
                    <div className="member-filter-grid">

                        <FilterSelect
                            label="Branch"
                            value={filters.branch}
                            onChange={(value) =>
                                setFilters({
                                    ...filters,
                                    branch: value,
                                })
                            }
                            options={uniqueValues("branch")}
                        />

                        <FilterSelect
                            label="Pincode"
                            value={filters.pincode}
                            onChange={(value) =>
                                setFilters({
                                    ...filters,
                                    pincode: value,
                                })
                            }
                            options={uniqueValues("pincode")}
                        />

                        <FilterSelect
                            label="State"
                            value={filters.state}
                            onChange={(value) =>
                                setFilters({
                                    ...filters,
                                    state: value,
                                    district: "",
                                })
                            }
                            options={uniqueValues("state")}
                        />

                        <FilterSelect
                            label="District"
                            value={filters.district}
                            onChange={(value) =>
                                setFilters({
                                    ...filters,
                                    district: value,
                                })
                            }
                            options={uniqueValues("district")}
                        />

                        <FilterSelect
                            label="Community"
                            value={filters.community}
                            onChange={(value) =>
                                setFilters({
                                    ...filters,
                                    community: value,
                                    subCommunity: "",
                                })
                            }
                            options={uniqueValues("community")}
                        />

                        <FilterSelect
                            label="Sub Community"
                            value={filters.subCommunity}
                            onChange={(value) =>
                                setFilters({
                                    ...filters,
                                    subCommunity: value,
                                })
                            }
                            options={uniqueValues("subCommunity")}
                        />

                        <FilterSelect
                            label="Caste"
                            value={filters.caste}
                            onChange={(value) =>
                                setFilters({
                                    ...filters,
                                    caste: value,
                                })
                            }
                            options={uniqueValues("caste")}
                        />

                        <FilterSelect
                            label="Gender"
                            value={filters.gender}
                            onChange={(value) =>
                                setFilters({
                                    ...filters,
                                    gender: value,
                                })
                            }
                            options={["Male", "Female"]}
                        />

                        <FilterSelect
                            label="Profession"
                            value={filters.profession}
                            onChange={(value) =>
                                setFilters({
                                    ...filters,
                                    profession: value,
                                })
                            }
                            options={uniqueValues("occupation")}
                        />

                        <FilterSelect
                            label="Horoscope"
                            value={filters.horoscope}
                            onChange={(value) =>
                                setFilters({
                                    ...filters,
                                    horoscope: value,
                                })
                            }
                            options={[
                                "Available",
                                "Not Available",
                            ]}
                        />

                    </div>
                )}

            </div>

            {/* TABLE */}
            <div className="members-table-card">

                <div className="table-card-header">
                    <div>
                        <h2>Member List</h2>
                        <span>
                            Showing {filteredMembers.length} of{" "}
                            {members.length} members
                        </span>
                    </div>
                </div>

                <div className="members-table-wrapper">

                    <table className="members-table">

                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Member ID</th>
                                <th>Profile</th>
                                <th>Name</th>
                                <th>Gender</th>
                                <th>Mobile</th>
                                <th>DOB</th>
                                <th>Community</th>
                                <th>Sub Community</th>
                                <th>Caste</th>
                                <th>Education</th>
                                <th>Profession</th>
                                <th>Annual Income</th>
                                <th>Branch</th>
                                <th>District</th>
                                <th>State</th>
                                <th>Pincode</th>
                                <th>Marital Status</th>
                                <th>Horoscope</th>
                                <th>Status</th>
                                <th>Action</th>
                                <th>Status Action</th>
                            </tr>
                        </thead>

                        <tbody>

                            {filteredMembers.length === 0 ? (
                                <tr>
                                    <td
                                        colSpan="21"
                                        className="empty-table"
                                    >
                                        No members found
                                    </td>
                                </tr>
                            ) : (
                                filteredMembers.map(
                                    (member, index) => (
                                        <tr key={member.id}>

                                            <td>
                                                {index + 1}
                                            </td>

                                            <td>
                                                <span className="member-id">
                                                    {member.memberId}
                                                </span>
                                            </td>

                                            <td>
                                                <div className="member-avatar">
                                                    {member.name
                                                        .charAt(0)
                                                        .toUpperCase()}
                                                </div>
                                            </td>

                                            <td>
                                                <strong>
                                                    {member.name}
                                                </strong>
                                            </td>

                                            <td>
                                                <span
                                                    className={`gender-badge ${member.gender.toLowerCase()}`}
                                                >
                                                    {member.gender}
                                                </span>
                                            </td>

                                            <td>
                                                <div className="mobile-cell">
                                                    <Phone size={14} />
                                                    {member.mobile}
                                                </div>
                                            </td>

                                            <td>
                                                {member.dateOfBirth}
                                            </td>

                                            <td>
                                                {member.community}
                                            </td>

                                            <td>
                                                {member.subCommunity}
                                            </td>

                                            <td>
                                                {member.caste}
                                            </td>

                                            <td>
                                                {member.education}
                                            </td>

                                            <td>
                                                {member.occupation}
                                            </td>

                                            <td>
                                                {member.annualIncome}
                                            </td>

                                            <td>
                                                {member.branch}
                                            </td>

                                            <td>
                                                {member.district}
                                            </td>

                                            <td>
                                                {member.state}
                                            </td>

                                            <td>
                                                {member.pincode}
                                            </td>

                                            <td>
                                                {member.maritalStatus}
                                            </td>

                                            <td>
                                                <span
                                                    className={`horoscope-badge ${member.horoscope ===
                                                        "Available"
                                                        ? "available"
                                                        : "not-available"
                                                        }`}
                                                >
                                                    {member.horoscope}
                                                </span>
                                            </td>

                                            <td>
                                                <button
                                                    className={`status-badge ${member.status ===
                                                        "Active"
                                                        ? "active"
                                                        : "inactive"
                                                        }`}
                                                    onClick={() =>
                                                        toggleStatus(
                                                            member.id
                                                        )
                                                    }
                                                >
                                                    {member.status}
                                                </button>
                                            </td>

                                            <td>
                                                <div className="member-actions">

                                                    <button
                                                        className="icon-btn view"
                                                        title="View"
                                                        onClick={() =>
                                                            setViewMember(
                                                                member
                                                            )
                                                        }
                                                    >
                                                        <Eye size={17} />
                                                    </button>
                                                </div>
                                            </td>
                                            <td>
                                                <button
                                                    className={`member-status-btn ${member.status === "Active"
                                                            ? "active"
                                                            : "inactive"
                                                        }`}
                                                    onClick={() => toggleStatus(member.id)}
                                                >
                                                    {member.status === "Active" ? "Active" : "Inactive"}
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                )
                            )}

                        </tbody>

                    </table>

                </div>

            </div>

            {/* VIEW MEMBER MODAL */}
            {viewMember && (
                <div className="member-modal-overlay">

                    <div className="member-view-modal">

                        <div className="member-modal-header">

                            <div>
                                <h2>Member Profile</h2>
                                <p>
                                    {viewMember.memberId}
                                </p>
                            </div>

                            <button
                                onClick={() =>
                                    setViewMember(null)
                                }
                            >
                                <X size={20} />
                            </button>

                        </div>

                        <div className="member-profile-header">

                            <div className="large-member-avatar">
                                {viewMember.name
                                    .charAt(0)
                                    .toUpperCase()}
                            </div>

                            <div>
                                <h3>
                                    {viewMember.name}
                                </h3>

                                <p>
                                    {viewMember.gender} •{" "}
                                    {viewMember.maritalStatus}
                                </p>

                                <span className="member-id">
                                    {viewMember.memberId}
                                </span>
                            </div>

                        </div>

                        <div className="profile-section">

                            <h3>Personal Information</h3>

                            <div className="profile-grid">

                                <InfoItem
                                    label="Gender"
                                    value={viewMember.gender}
                                />

                                <InfoItem
                                    label="Place of Birth"
                                    value={viewMember.placeOfBirth}
                                />

                                <InfoItem
                                    label="Date of Birth"
                                    value={viewMember.dateOfBirth}
                                />

                                <InfoItem
                                    label="Time of Birth"
                                    value={viewMember.timeOfBirth}
                                />

                                <InfoItem
                                    label="Mobile Number"
                                    value={viewMember.mobile}
                                />

                                <InfoItem
                                    label="Native Place"
                                    value={viewMember.nativePlace}
                                />

                                <InfoItem
                                    label="Height"
                                    value={viewMember.height}
                                />

                                <InfoItem
                                    label="Weight"
                                    value={viewMember.weight}
                                />

                                <InfoItem
                                    label="Color"
                                    value={viewMember.color}
                                />

                                <InfoItem
                                    label="Marital Status"
                                    value={viewMember.maritalStatus}
                                />

                            </div>

                        </div>

                        <div className="profile-section">

                            <h3>Community Information</h3>

                            <div className="profile-grid">

                                <InfoItem
                                    label="Community"
                                    value={viewMember.community}
                                />

                                <InfoItem
                                    label="Sub Community"
                                    value={
                                        viewMember.subCommunity
                                    }
                                />

                                <InfoItem
                                    label="Caste"
                                    value={viewMember.caste}
                                />

                                <InfoItem
                                    label="Horoscope"
                                    value={viewMember.horoscope}
                                />

                            </div>

                        </div>

                        <div className="profile-section">

                            <h3>Family Information</h3>

                            <div className="profile-grid">

                                <InfoItem
                                    label="Father Name"
                                    value={viewMember.fatherName}
                                />

                                <InfoItem
                                    label="Mother Name"
                                    value={viewMember.motherName}
                                />

                                <InfoItem
                                    label="No. of Siblings"
                                    value={viewMember.siblings}
                                />

                                <InfoItem
                                    label="Family Type"
                                    value={viewMember.familyType}
                                />

                                <InfoItem
                                    label="Family Temple"
                                    value={viewMember.familyTemple}
                                />

                                <InfoItem
                                    label="Temple Place"
                                    value={
                                        viewMember.familyTemplePlace
                                    }
                                />

                                <InfoItem
                                    label="Family Assets"
                                    value={viewMember.familyAssets}
                                />

                            </div>

                        </div>

                        <div className="profile-section">

                            <h3>Education & Profession</h3>

                            <div className="profile-grid">

                                <InfoItem
                                    label="Highest Education"
                                    value={viewMember.education}
                                />

                                <InfoItem
                                    label="Occupation"
                                    value={viewMember.occupation}
                                />

                                <InfoItem
                                    label="Company"
                                    value={viewMember.company}
                                />

                                <InfoItem
                                    label="Designation"
                                    value={viewMember.designation}
                                />

                                <InfoItem
                                    label="Annual Income"
                                    value={viewMember.annualIncome}
                                />

                                <InfoItem
                                    label="Work Location"
                                    value={viewMember.workLocation}
                                />

                                <InfoItem
                                    label="Languages"
                                    value={
                                        viewMember.languages
                                    }
                                />

                            </div>

                        </div>

                        <div className="profile-section">

                            <h3>Branch Information</h3>

                            <div className="profile-grid">

                                <InfoItem
                                    label="Branch"
                                    value={viewMember.branch}
                                />

                                <InfoItem
                                    label="State"
                                    value={viewMember.state}
                                />

                                <InfoItem
                                    label="District"
                                    value={viewMember.district}
                                />

                                <InfoItem
                                    label="Pincode"
                                    value={viewMember.pincode}
                                />

                                <InfoItem
                                    label="Profile Created By"
                                    value={
                                        viewMember.profileCreatedBy
                                    }
                                />

                            </div>

                        </div>

                        <div className="member-modal-footer">

                            <button
                                className="secondary-btn"
                                onClick={() =>
                                    setViewMember(null)
                                }
                            >
                                Close
                            </button>

                        </div>

                    </div>

                </div>
            )}

        </div>
    );
}

function FilterSelect({
    label,
    value,
    onChange,
    options,
}) {
    return (
        <div className="filter-field">

            <label>{label}</label>

            <div className="filter-select-wrapper">

                <select
                    value={value}
                    onChange={(e) =>
                        onChange(e.target.value)
                    }
                >
                    <option value="">
                        All {label}
                    </option>

                    {options.map((option) => (
                        <option
                            key={option}
                            value={option}
                        >
                            {option}
                        </option>
                    ))}
                </select>

                <ChevronDown size={15} />

            </div>

        </div>
    );
}

function InfoItem({ label, value }) {
    return (
        <div className="info-item">

            <span>{label}</span>

            <strong>
                {value || "-"}
            </strong>

        </div>
    );
}

function FormInput({
    label,
    name,
    value,
    onChange,
    type = "text",
}) {
    return (
        <div className="form-field">

            <label>{label}</label>

            <input
                type={type}
                name={name}
                value={value || ""}
                onChange={onChange}
            />

        </div>
    );
}

export default Members;